import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { BatchStatusT, BatchT } from '../types/batch';
import customFetch from '../utils/fetch';
export const useGetBatchInProject = (projectId?: number, enabled = true) => {
  return useQuery<BatchStatusT[], Error>({
    queryKey: ['getBatchInProject', projectId],
    enabled: enabled && projectId !== null,
    queryFn: async () => {
      const batchResponse = await customFetch(`${BASE_API_URL}/projects/${projectId}/batch`, {});
      if (!batchResponse.ok) {
        const err1 = await batchResponse.json();
        throw new Error(err1.error || 'Failed to fetch batches');
      }
      const batches = (await batchResponse.json() as BatchT[]);
      const statusPromises = batches.map(async b => {
        const batchStatusRequest = await customFetch(`${BASE_API_URL}/batch/${b.id}`, {});
        if (!batchStatusRequest.ok) {
          const err2 = await batchStatusRequest.json();
          throw new Error(err2.error || 'Failed to fetch batch status');
        }
        const body = (await batchStatusRequest.json() as {
          success: boolean;
          error: string | null;
          data: BatchStatusT;
        });
        if (!body.success) {
          throw new Error(body.error || 'Failed to fetch batch status');
        }
        return {
          ...body.data,
          inputCsvPath: b.inputCsvPath
        };
      });
      return Promise.all(statusPromises);
    },
    retry: false
  });
};